export const reportConstants ={
    GET_SALESREPORT_REQUEST: 'GET_SALESREPORT_REQUEST',
    GET_SALESREPORT_SUCCESS: 'GET_SALESREPORT_SUCCESS',
    GET_SALESREPORT_FAILURE: 'GET_SALESREPORT_FAILURE',
    GET_REFUNDREPORT_REQUEST: 'GET_REFUNDREPORT_REQUEST',
    GET_REFUNDREPORT_SUCCESS: 'GET_REFUNDREPORT_SUCCESS',
    GET_REFUNDREPORT_FAILURE: 'GET_REFUNDREPORT_FAILURE',

    GET_REFUNDARCHIVEREPORT_REQUEST: 'GET_REFUNDARCHIVEREPORT_REQUEST',
    GET_REFUNDARCHIVEREPORT_SUCCESS: 'GET_REFUNDARCHIVEREPORT_SUCCESS',
    GET_REFUNDARCHIVEREPORT_FAILURE: 'GET_REFUNDARCHIVEREPORT_FAILURE',
    GET_TRANSACTIONREPORT_REQUEST: 'GET_TRANSACTIONREPORT_REQUEST',
    GET_TRANSACTIONREPORT_SUCCESS: 'GET_TRANSACTIONREPORT_SUCCESS',
    GET_TRANSACTIONREPORT_FAILURE: 'GET_TRANSACTIONREPORT_FAILURE',

     GET_ALLTRANSACTIONREPORT_REQUEST: 'GET_ALLTRANSACTIONREPORT_REQUEST',
    GET_ALLTRANSACTIONREPORT_SUCCESS: 'GET_ALLTRANSACTIONREPORT_SUCCESS',
    GET_ALLTRANSACTIONREPORT_FAILURE: 'GET_ALLTRANSACTIONREPORT_FAILURE',
    GET_PAYOUTREPORT_REQUEST: 'GET_PAYOUTREPORT_REQUEST',
    GET_PAYOUTREPORT_SUCCESS: 'GET_PAYOUTREPORT_SUCCESS',
    GET_PAYOUTREPORT_FAILURE: 'GET_PAYOUTREPORT_FAILURE',
    POST_REPORT_REQUEST: 'POST_REPORT_REQUEST',
    POST_REPORT_SUCCESS: 'POST_REPORT_SUCCESS',
    POST_REPORT_FAILURE: 'POST_REPORT_FAILURE',
    GET_MONTH_REQUEST: 'GET_MONTH_REQUEST',
    GET_MONTH_SUCCESS: 'GET_MONTH_SUCCESS',
    GET_MONTH_FAILURE: 'GET_MONTH_FAILURE',
    GET_PAYOUTDETAIL_REQUEST: 'GET_PAYOUTDETAIL_REQUEST',
    GET_PAYOUTDETAIL_SUCCESS: 'GET_PAYOUTDETAIL_SUCCESS',
    GET_PAYOUTDETAIL_FAILURE: 'GET_PAYOUTDETAIL_FAILURE',
    POST_MARKPAYMENT_REQUEST: 'POST_MARKPAYMENT_REQUEST',
    POST_MARKPAYMENT_SUCCESS: 'POST_MARKPAYMENT_SUCCESS',
    POST_MARKPAYMENT_FAILURE: 'POST_MARKPAYMENT_FAILURE',
    POST_COMMENT_REQUEST: 'POST_COMMENT_REQUEST',
    POST_COMMENT_SUCCESS: 'POST_COMMENT_SUCCESS',
    POST_COMMENT_FAILURE: 'POST_COMMENT_FAILURE',
    GET_COMMENT_REQUEST: 'GET_COMMENT_REQUEST',
    GET_COMMENT_SUCCESS: 'GET_COMMENT_SUCCESS',
    GET_COMMENT_FAILURE: 'GET_COMMENT_FAILURE',
    GET_PAYOUTHISTORY_REQUEST: 'GET_PAYOUTHISTORY_REQUEST',
    GET_PAYOUTHISTORY_SUCCESS: 'GET_PAYOUTHISTORY_SUCCESS',
    GET_PAYOUTHISTORY_FAILURE: 'GET_PAYOUTHISTORY_FAILURE',
    EXPORT_AUCTION_BIDDER_REQUEST: 'EXPORT_AUCTION_BIDDER_REQUEST',
    EXPORT_AUCTION_BIDDER_SUCCESS: 'EXPORT_AUCTION_BIDDER_SUCCESS',
    EXPORT_AUCTION_BIDDER_FAILURE: 'EXPORT_AUCTION_BIDDER_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/reportConstants.js